import { useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import ProductCard from '@/components/ProductCard'
import Skeleton from '@/components/Skeleton'
import { useProductsByCategory } from '@/hooks/useProductsByCategory'

export default function JasaList() {
  const { products, loading, loadingMore, hasMore, loadMore } =
    useProductsByCategory('semua', 'jasa')

  const sentinelRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const el = sentinelRef.current
    if (!el) return
    const observer = new IntersectionObserver(
      entries => { if (entries[0].isIntersecting) loadMore() },
      { rootMargin: '0px 0px 400px 0px' }
    )
    observer.observe(el)
    return () => observer.disconnect()
  }, [loadMore])

  return (
    <div className="max-w-7xl mx-auto px-4 py-6">
      <div className="flex items-center gap-2 mb-4">
        <span className="w-2 h-2 rounded-full bg-emerald-600" />
        <h1 className="text-lg font-semibold text-gray-800">Layanan</h1>
      </div>

      {loading ? (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {[...Array(8)].map((_, i) => <Skeleton key={i} className="h-52" />)}
        </div>
      ) : products.length === 0 ? (
        <div className="text-center py-12">
          <p className="text-sm text-gray-400">Belum ada layanan.</p>
          <Link to="/" className="mt-3 inline-block text-sm text-blue-600 hover:underline">
            Kembali ke Beranda
          </Link>
        </div>
      ) : (
        <>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            {products.map(p => <ProductCard key={p.id} product={p} />)}
          </div>

          {loadingMore && (
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mt-3">
              {[...Array(4)].map((_, i) => <Skeleton key={i} className="h-52" />)}
            </div>
          )}

          <div ref={sentinelRef} className="h-1" />

          {!hasMore && products.length > 0 && (
            <p className="text-center text-xs text-gray-400 mt-4">Semua layanan sudah ditampilkan.</p>
          )}
        </>
      )}
    </div>
  )
}
